import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetTranscriptState } from 'actions/shareVideo';

import {
  fetchTranscriptPhrases,
  subscribeToTranscriptStatus,
} from '../../../creators/shareVideo';

const FetchTranscript = () => {
  const dispatch = useDispatch();

  const [subscription, setSubscription] = useState();
  const [didFirstFetch, setDidFirstFetch] = useState(false);
  const [fetchTranscriptError, setFetchTranscriptError] = useState(null);

  const sendingNewTrim = useSelector(state => state.trimming.sendingNewTrim);
  const transcript = useSelector(state => state.share_video.transcript);
  const userCanAccessTranscript = useSelector(
    state => state.share_video.userCanAccessTranscript
  );
  const activeTranscriptId = useSelector(
    state => state.video_player.video.active_video_transcript_id
  );

  // Initial fetching
  useEffect(() => {
    if (activeTranscriptId && userCanAccessTranscript && !didFirstFetch) {
      console.log('transcriptions: Initial fetch');

      dispatch(fetchTranscriptPhrases())
        .catch(err => {
          setFetchTranscriptError(err);
          console.error('unable to fetch initial transcription', err);
        })
        .finally(() => {
          setDidFirstFetch(true);
        });
    }
  }, [activeTranscriptId, didFirstFetch, dispatch, userCanAccessTranscript]);

  // Subscribes and watches for transcription status changes
  useEffect(() => {
    if (
      activeTranscriptId &&
      userCanAccessTranscript &&
      didFirstFetch &&
      !transcript &&
      !subscription &&
      !fetchTranscriptError
    ) {
      console.log('transcriptions: Subscribing');

      const subscription = dispatch(subscribeToTranscriptStatus());

      if (subscription) {
        setSubscription(subscription);
      }
    }

    return () => {
      subscription?.unsubscribe();
    };
  }, [
    activeTranscriptId,
    didFirstFetch,
    dispatch,
    subscription,
    transcript,
    userCanAccessTranscript,
    fetchTranscriptError,
  ]);

  // makes sure we unsubscribe from pub/sub if we get a new transcript
  useEffect(() => {
    if (transcript && subscription) {
      console.log('transcriptions: Unsubscribing');

      subscription.unsubscribe();
      setSubscription(null);
    }
  }, [transcript, subscription]);

  // Watches for trim changes. Resets the transcription state
  // which will trigger the other effect of subscribing for changes
  useEffect(
    () => {
      if (!didFirstFetch) {
        return;
      }

      if (!sendingNewTrim) {
        console.log(
          'transcriptions: Trim changed. Refetching and resubscribing for transcript changes'
        );

        dispatch(resetTranscriptState());
      }
    },
    // We don't care if 'didFirstFetch' changed so we are omitting it from
    // the list to prevent 'resetTranscriptState' to be called excessively
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, sendingNewTrim]
  );

  return null;
};

export default FetchTranscript;
